export function extend(destination, source) {
  for (var property in source) {
    destination[property] = source[property];
  }
  return destination;
}

export function formatQueryStringParams(params) {
  if (typeof params == 'undefined') return '';
  return "?" + Object
    .keys(params)
    .map(function (key) {
      return key + "=" + encodeURIComponent(params[key])
    })
    .join("&")
}

export function parseHashParams() {
  return parseUrlParams(window.location.hash.substring(1))
}

export function parseQueryStringParams() {
  return parseUrlParams(window.location.search.substring(1))
}

export function parsehashBangQueryStringParams() {
  return parseUrlParams(window.location.hash.replace(/.*\?/, ''))
}

export function parseUrlParams(input) {
  var vars = input.split('&');
  var params = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return params;
}

/* Options:
 * method (required)
 * baseurl (required)
 * qs_params
 * body_data
 * transform_fn
 * callback
 * jwt_token
 */
export function xhr(options) {
  if (typeof options.callback == 'undefined') options.callback = function () {}
  if (typeof options.transform_fn == 'undefined') options.transform_fn = function (o) {
    return o;
  }
  if (typeof options.headers == 'undefined') options.headers = {}

  var xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState != 4) return
    // console.log('XHR completed with HTTP code ' + xmlHttp.status)

    if (xmlHttp.status != 200) {
      options.callback(xmlHttp);
      return;
    }

    try {
      var data = JSON.parse(xmlHttp.responseText);
      data = options.transform_fn(data);
      options.callback(undefined, data);
    } catch (e) {
      options.callback(e);
    }
  }

  var url = options.baseurl + formatQueryStringParams(options.qs_params)
  // console.log(options.method + " " + url)
  xmlHttp.open(options.method, url, true);

  if (options.method.toLowerCase() == 'post' && options.json) {
    // xmlHttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xmlHttp.setRequestHeader("Content-Type", "application/json");
  }

  xmlHttp.onerror = function (e) {
    // console.log("Server is down?");
    options.callback(e)
  };

  if (typeof options.jwt_token != 'undefined') {
    xmlHttp.setRequestHeader('Authorization', 'Bearer ' + options.jwt_token);
  }

  for (var k in options.headers) {
    xmlHttp.setRequestHeader(k, options.headers[k]);
  }
  
  try {
    xmlHttp.send(options.body_data);
  } catch (e) {
    // not invoked on chrome
    // console.log("Server is down?");
    options.callback(e)
  }
}

export function onload(f) {
  if (window.addEventListener) {
    window.addEventListener('load', f)
  } else {
    window.attachEvent('onload', f)
  }
}


export function msToTime(s) {
  var ms = s % 1000;
  s = (s - ms) / 1000;
  var secs = s % 60;
  s = (s - secs) / 60;
  var mins = s % 60;
  s = (s - mins) / 60;
  var hrs = s % 24;
  var days = (s - hrs) / 24;

  return days + 'days ' + hrs + 'hours ' + mins + 'minutes ' + secs + 'seconds';
}


export function load_js_dynamically(jsid, jsurl, callback) {
  (function (d, s, id) {
    var js, ajs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = jsurl;
    js.onload = callback;
    ajs.parentNode.insertBefore(js, ajs);
  }(document, 'script', jsid));
}

export function guid() {
  var S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}


//////////////////
// WEBPACK FOOTER
// ../js-utils/utils.js
// module id = uYYH
// module chunks = 1